// 物件種別リスト
export const PROPERTY_TYPES = [
  { key: "assessment", label: "投資用" },
  { key: "residence", label: "居住用" },
];

// 地区リスト
export const cityList = [
  "世田谷区", "中央区", "中野区", "北区", "千代田区", "台東区", "品川区", "墨田区", "大田区", "文京区",
  "新宿区", "杉並区", "板橋区", "江戸川区", "江東区", "渋谷区", "港区", "目黒区", "練馬区", "荒川区",
  "葛飾区", "豊島区", "足立区", "あきる野市", "三鷹市", "八王子市", "国分寺市", "国立市", "多摩市",
  "小平市", "小金井市", "府中市", "日野市", "昭島市", "東久留米市", "東大和市", "東村山市", "武蔵村山市",
  "武蔵野市", "清瀬市", "狛江市", "町田市", "福生市", "稲城市", "立川市", "羽村市", "西多摩郡瑞穂町",
  "西東京市", "調布市", "青梅市"
];

// 市区町村リスト
export const districtList = [
  "お花茶屋",
  "たかの台",
  "つつじが丘",
  "ひばりが丘",
  "ひばりが丘北",
  "ひばりが丘団地",
  "みなみ野",
  "めじろ台",
  "もくせいの杜",
  "一ツ家",
  "一ノ宮",
  "一之江",
  "一之江町",
  "一番町",
  "七国",
  "万町",
  "万願寺",
  "三ノ輪",
  "三原台",
  "三園",
  "三好",
  "三宿",
  "三崎町",
  "三沢",
  "三田",
  "三番町",
  "三筋",
  "三軒茶屋",
  "三輪町",
  "三輪緑山",
  "上一色",
  "上中里",
  "上井草",
  "上北台",
  "上北沢",
  "上十条",
  "上原",
  "上大崎",
  "上板橋",
  "上柚木",
  "上水南町",
  "上水本町",
  "上池台",
  "上池袋",
  "上清戸",
  "上用賀",
  "上町",
  "上目黒",
  "上石原",
  "上石神井",
  "上石神井南町",
  "上砂町",
  "上祖師谷",
  "上篠崎",
  "上荻",
  "上落合",
  "上連雀",
  "上野",
  "上野桜木",
  "上野毛",
  "上野町",
  "上馬",
  "上高井戸",
  "上高田",
  "上鷺宮",
  "下丸子",
  "下井草",
  "下保谷",
  "下宮比町",
  "下柚木",
  "下清戸",
  "下目黒",
  "下石原",
  "下石神井",
  "下篠崎町",
  "下落合",
  "下谷",
  "下連雀",
  "下里",
  "下馬",
  "下高井戸",
  "世田谷",
  "両国",
  "並木町",
  "中",
  "中丸町",
  "中井",
  "中十条",
  "中原",
  "中台",
  "中和泉",
  "中央",
  "中央本町",
  "中央町",
  "中川",
  "中延",
  "中村",
  "中村北",
  "中村南",
  "中板橋",
  "中根",
  "中沢",
  "中清戸",
  "中町",
  "中目黒",
  "中神町",
  "中落合",
  "中葛西",
  "中里",
  "中里町",
  "中野",
  "中野上町",
  "中野山王",
  "中馬込",
  "丸山",
  "久が原",
  "久保山町",
  "久我山",
  "久米川町",
  "九段北",
  "九段南",
  "乞田",
  "亀戸",
  "亀有",
  "亀沢",
  "二十騎町",
  "二番町",
  "二葉",
  "五ノ神",
  "五本木",
  "五番町",
  "井の頭",
  "井口",
  "井草",
  "京島",
  "京橋",
  "今川",
  "今戸",
  "仙川町",
  "代々木",
  "代官山町",
  "代沢",
  "代田",
  "仲六郷",
  "仲宿",
  "仲池上",
  "仲町",
  "伊奈平",
  "伊興",
  "伊興本町",
  "佃",
  "住吉",
  "住吉町",
  "住江町",
  "佐賀",
  "佐野",
  "佐須町",
  "余丁町",
  "保塚町",
  "保木間",
  "保谷町",
  "信濃町",
  "元代々木町",
  "元和泉",
  "元本郷町",
  "元横山町",
  "元浅草",
  "元町",
  "元赤坂",
  "元麻布",
  "光が丘",
  "光町",
  "入船",
  "入谷",
  "入間町",
  "八丁堀",
  "八幡山",
  "八幡町",
  "八広",
  "八日町",
  "八木町",
  "八潮",
  "八雲",
  "八雲台",
  "六月",
  "六木",
  "六本木",
  "六町",
  "六番町",
  "兵衛",
  "内神田",
  "内藤",
  "内藤町",
  "円山町",
  "冬木",
  "分梅町",
  "初台",
  "初沢町",
  "別所",
  "前原町",
  "前沢",
  "前野町",
  "加平",
  "加美平",
  "加賀",
  "勝どき",
  "勝島",
  "勝沼",
  "北",
  "北上野",
  "北加平町",
  "北千束",
  "北原町",
  "北品川",
  "北大塚",
  "北小岩",
  "北山伏町",
  "北山町",
  "北嶺町",
  "北新宿",
  "北沢",
  "北烏山",
  "北田園",
  "北町",
  "北砂",
  "北篠崎",
  "北糀谷",
  "北葛西",
  "北野",
  "北野台",
  "北野町",
  "北青山",
  "北馬込",
  "十条仲原",
  "十条台",
  "千ヶ瀬町",
  "千人町",
  "千住",
  "千住中居町",
  "千住仲町",
  "千住元町",
  "千住大川町",
  "千住宮元町",
  "千住寿町",
  "千住旭町",
  "千住曙町",
  "千住東",
  "千住桜木",
  "千住橋戸町",
  "千住河原町",
  "千住緑町",
  "千住関屋町",
  "千住龍田町",
  "千川",
  "千早",
  "千束",
  "千歳",
  "千歳台",
  "千田",
  "千石",
  "千駄ヶ谷",
  "千駄木",
  "千鳥",
  "南",
  "南つくし野",
  "南久が原",
  "南元町",
  "南六郷",
  "南千住",
  "南千束",
  "南台",
  "南品川",
  "南大井",
  "南大塚",
  "南大沢",
  "南大泉",
  "南大谷",
  "南小岩",
  "南山伏町",
  "南常盤台",
  "南平",
  "南平台町",
  "南成瀬",
  "南新町",
  "南榎町",
  "南水元",
  "南池袋",
  "南沢",
  "南烏山",
  "南田中",
  "南町",
  "南町田",
  "南砂",
  "南篠崎町",
  "南花畑",
  "南荻窪",
  "南葛西",
  "南蒲田",
  "南街",
  "南野",
  "南長崎",
  "南雪谷",
  "南青山",
  "南馬込",
  "南麻布",
  "原町",
  "原町田",
  "友田町",
  "双葉町",
  "古千谷本町",
  "古石場",
  "台場",
  "台東",
  "台町",
  "叶谷町",
  "吉祥寺北町",
  "吉祥寺南町",
  "吉祥寺本町",
  "吉祥寺東町",
  "向丘",
  "向原",
  "向台町",
  "向山",
  "向島",
  "向陽台",
  "吾妻橋",
  "和泉",
  "和泉本町",
  "和田",
  "唐木田",
  "善福寺",
  "喜久井町",
  "喜多見",
  "喜平町",
  "四つ木",
  "四番町",
  "四葉",
  "四谷",
  "四谷三栄町",
  "四谷坂町",
  "四谷本塩町",
  "四谷町",
  "回田町",
  "図師町",
  "国領町",
  "土支田",
  "坂下",
  "堀ノ内",
  "堀之内",
  "堀切",
  "堀船",
  "堤通",
  "塩浜",
  "境",
  "境南町",
  "墨田",
  "外神田",
  "多摩川",
  "多摩平",
  "多摩湖町",
  "大丸",
  "大久保",
  "大井",
  "大京町",
  "大南",
  "大原",
  "大原町",
  "大和田町",
  "大和町",
  "大坂上",
  "大塚",
  "大字宮",
  "大字新井",
  "大字日野",
  "大字熊川",
  "大字福生",
  "大字箱根ヶ崎",
  "大宮",
  "大山東町",
  "大山町",
  "大山西町",
  "大山金井町",
  "大岡山",
  "大島",
  "大崎",
  "大杉",
  "大柳町",
  "大森中",
  "大森北",
  "大森南",
  "大森本町",
  "大森東",
  "大森西",
  "大横町",
  "大橋",
  "大沢",
  "大沼町",
  "大泉学園町",
  "大泉町",
  "大神町",
  "大蔵",
  "大蔵町",
  "大谷口",
  "大谷口上町",
  "大谷口北町",
  "大谷田",
  "大谷町",
  "大門",
  "大門町",
  "天ヶ瀬町",
  "天沼",
  "天神町",
  "太子堂",
  "太平",
  "奥戸",
  "奥沢",
  "子安町",
  "学園",
  "学園東町",
  "学園町",
  "学園西町",
  "宇喜田町",
  "宇奈根",
  "宇田川町",
  "宝町",
  "宮前",
  "宮坂",
  "宮城",
  "宮本町",
  "宮沢町",
  "宮町",
  "宮西町",
  "富ヶ谷",
  "富久町",
  "富士本",
  "富士町",
  "富士見",
  "富士見台",
  "富士見平",
  "富士見町",
  "富岡",
  "寺田町",
  "寺町",
  "寿",
  "寿町",
  "小作台",
  "小台",
  "小山",
  "小山ヶ丘",
  "小山台",
  "小山田桜台",
  "小山町",
  "小島",
  "小島町",
  "小川",
  "小川東町",
  "小川町",
  "小川西町",
  "小日向",
  "小松川",
  "小柳町",
  "小比企町",
  "小石川",
  "小竹町",
  "小茂根",
  "小菅",
  "小豆沢",
  "小野路町",
  "尾山台",
  "山吹町",
  "山崎",
  "山崎町",
  "山王",
  "山王下",
  "山田町",
  "岡本",
  "岩戸北",
  "岩戸南",
  "岩戸町",
  "岩本町",
  "岩淵町",
  "岸町",
  "島根",
  "川口町",
  "川崎",
  "巣鴨",
  "左入町",
  "左門町",
  "市谷仲之町",
  "市谷八幡町",
  "市谷加賀町",
  "市谷台町",
  "市谷山伏町",
  "市谷左内町",
  "市谷本村町",
  "市谷柳町",
  "市谷田町",
  "市谷甲良町",
  "市谷砂土原町",
  "市谷船河原町",
  "市谷薬王寺町",
  "布田",
  "師岡町",
  "常盤",
  "常盤台",
  "幡ヶ谷",
  "平井",
  "平和台",
  "平塚",
  "平尾",
  "平山",
  "平河町",
  "平町",
  "平野",
  "幸町",
  "広尾",
  "府中町",
  "廻田町",
  "弁天町",
  "弘道",
  "弥生",
  "弥生町",
  "弦巻",
  "後楽",
  "御幸町",
  "御殿山",
  "徳丸",
  "志村",
  "志茂",
  "忠生",
  "恩多町",
  "恵比寿",
  "恵比寿南",
  "恵比寿西",
  "愛住町",
  "愛宕",
  "成城",
  "成増",
  "成瀬",
  "成田東",
  "成田西",
  "戸倉",
  "戸吹町",
  "戸塚町",
  "戸山",
  "戸越",
  "扇",
  "扇橋",
  "打越町",
  "払方町",
  "押上",
  "押立",
  "押立町",
  "拝島町",
  "改代町",
  "散田町",
  "文花",
  "新井",
  "新堀",
  "新大橋",
  "新宿",
  "新富",
  "新小岩",
  "新小川町",
  "新川",
  "新川町",
  "新橋",
  "新河岸",
  "新田",
  "新町",
  "新砂",
  "新蒲田",
  "方南",
  "旗の台",
  "日ノ出町",
  "日吉町",
  "日向和田",
  "日新町",
  "日本堤",
  "日本橋",
  "日本橋中洲",
  "日本橋久松町",
  "日本橋人形町",
  "日本橋兜町",
  "日本橋堀留町",
  "日本橋大伝馬町",
  "日本橋室町",
  "日本橋富沢町",
  "日本橋小伝馬町",
  "日本橋小網町",
  "日本橋小舟町",
  "日本橋本町",
  "日本橋横山町",
  "日本橋浜町",
  "日本橋箱崎町",
  "日本橋茅場町",
  "日本橋蛎殻町",
  "日本橋馬喰町",
  "日野台",
  "日野本町",
  "日鋼町",
  "早宮",
  "早稲田南町",
  "早稲田町",
  "早稲田鶴巻町",
  "旭が丘",
  "旭丘",
  "旭町",
  "明石町",
  "明神町",
  "春日",
  "春日町",
  "春江町",
  "昭和町",
  "是政",
  "晴海",
  "晴見町",
  "暁町",
  "曙町",
  "月島",
  "有明",
  "朝日町",
  "木場",
  "木曽東",
  "末広町",
  "本一色",
  "本多",
  "本天沼",
  "本宿町",
  "本所",
  "本木北町",
  "本町",
  "本町田",
  "本羽田",
  "本郷",
  "本駒込",
  "東",
  "東が丘",
  "東つつじヶ丘",
  "東上野",
  "東中延",
  "東中野",
  "東五反田",
  "東五軒町",
  "東伊興",
  "東伏見",
  "東保木間",
  "東元町",
  "東六月町",
  "東六郷",
  "東十条",
  "東向島",
  "東和",
  "東和泉",
  "東品川",
  "東四つ木",
  "東坂下",
  "東堀切",
  "東墨田",
  "東大井",
  "東大泉",
  "東寺方",
  "東小岩",
  "東小松川",
  "東尾久",
  "東山",
  "東山町",
  "東嶺町",
  "東平山",
  "東恋ヶ窪",
  "東戸倉",
  "東新小岩",
  "東新橋",
  "東新町",
  "東日暮里",
  "東日本橋",
  "東本町",
  "東榎町",
  "東水元",
  "東池袋",
  "東浅川町",
  "東浅草",
  "東玉川",
  "東玉川学園",
  "東瑞江",
  "東田端",
  "東町",
  "東矢口",
  "東砂",
  "東神田",
  "東立石",
  "東糀谷",
  "東綾瀬",
  "東芝町",
  "東葛西",
  "東蒲田",
  "東豊田",
  "東野川",
  "東金町",
  "東長沼",
  "東陽",
  "東雪谷",
  "東雲",
  "東青梅",
  "東馬込",
  "東駒形",
  "東麻布",
  "松が丘",
  "松が谷",
  "松ノ木",
  "松原",
  "松原町",
  "松山",
  "松島",
  "松庵",
  "松木",
  "松江",
  "松濤",
  "板橋",
  "枝川",
  "柏町",
  "染地",
  "柳原",
  "柳橋",
  "柳沢",
  "柳窪",
  "柴又",
  "柴崎",
  "柴崎町",
  "柿の木坂",
  "栄町",
  "栗原",
  "根ヶ布",
  "根岸",
  "根津",
  "桃井",
  "桐ヶ丘",
  "桜",
  "桜が丘",
  "桜上水",
  "桜丘",
  "桜丘町",
  "桜台",
  "桜堤",
  "桜川",
  "桜新町",
  "桜町",
  "梅丘",
  "梅園",
  "梅島",
  "梅田",
  "梅里",
  "梶野町",
  "森下",
  "森野",
  "椚田町",
  "椿",
  "業平",
  "榎町",
  "横寺町",
  "横山町",
  "横川",
  "横川町",
  "横網",
  "橋場",
  "歌舞伎町",
  "武蔵台",
  "武蔵野",
  "武蔵野台",
  "毛利",
  "水元",
  "水道",
  "水道町",
  "氷川台",
  "氷川町",
  "永代",
  "永山",
  "永田町",
  "永福",
  "江北",
  "江原町",
  "江古田",
  "江戸川",
  "江東橋",
  "池上",
  "池之端",
  "池尻",
  "池袋",
  "池袋本町",
  "河田町",
  "河辺町",
  "沼袋",
  "泉",
  "泉町",
  "洗足",
  "浅草",
  "浅草橋",
  "浅間町",
  "浜松町",
  "浜田山",
  "浮間",
  "海岸",
  "海辺",
  "深大寺",
  "深大寺元町",
  "深大寺南町",
  "深大寺東町",
  "深川",
  "深沢",
  "清川",
  "清新町",
  "清水",
  "清水が丘",
  "清水町",
  "清澄",
  "渋谷",
  "港南",
  "湊",
  "湖畔",
  "湯島",
  "滝ノ上町",
  "滝山",
  "滝野川",
  "潮見",
  "瀬田",
  "熊野町",
  "片倉町",
  "片町",
  "牛浜",
  "牟礼",
  "牡丹",
  "狭間町",
  "猪方",
  "猿楽町",
  "猿江",
  "玉堤",
  "玉川",
  "玉川台",
  "玉川学園",
  "玉川田園調布",
  "玉川町",
  "王子",
  "王子本町",
  "瑞江",
  "用賀",
  "田中町",
  "田園調布",
  "田園調布南",
  "田園調布本町",
  "田柄",
  "田無町",
  "田端",
  "田端新町",
  "町屋",
  "畑中",
  "白山",
  "白河",
  "白糸台",
  "白金",
  "白金台",
  "白銀町",
  "白鳥",
  "白鷺",
  "百人町",
  "百村",
  "百草",
  "皿沼",
  "目白",
  "目白台",
  "目黒",
  "目黒本町",
  "相原町",
  "相生町",
  "真光寺",
  "矢口",
  "矢崎町",
  "矢川",
  "矢来町",
  "矢野口",
  "石原",
  "石島",
  "石川町",
  "石神井台",
  "石神井町",
  "砂川町",
  "砧",
  "碑文谷",
  "祐天寺",
  "祖師谷",
  "神南",
  "神宝町",
  "神宮前",
  "神山町",
  "神明",
  "神明南",
  "神明台",
  "神楽坂",
  "神泉町",
  "神田三崎町",
  "神田佐久間町",
  "神田司町",
  "神田和泉町",
  "神田多町",
  "神田富山町",
  "神田小川町",
  "神田東松下町",
  "神田東紺屋町",
  "神田淡路町",
  "神田猿楽町",
  "神田神保町",
  "神田練塀町",
  "神田美土代町",
  "神田錦町",
  "神田鍛冶町",
  "神田須田町",
  "神田駿河台",
  "神谷",
  "福住",
  "福島町",
  "秋川",
  "秋津町",
  "秋留",
  "程久保",
  "稲荷台",
  "立川",
  "立石",
  "立花",
  "立野",
  "立野町",
  "竜泉",
  "竹の塚",
  "竹丘",
  "笹塚",
  "等々力",
  "筑土八幡町",
  "箪笥町",
  "箱根ヶ崎東松原",
  "築地",
  "築地町",
  "篠崎町",
  "粕谷",
  "紀尾井町",
  "紅葉丘",
  "納戸町",
  "細工町",
  "細田",
  "経堂",
  "給田",
  "絹ヶ丘",
  "綾瀬",
  "緑",
  "緑が丘",
  "緑ヶ丘",
  "緑町",
  "練馬",
  "美住町",
  "美園町",
  "美堀町",
  "美好町",
  "羽東",
  "羽根木",
  "羽沢",
  "羽田",
  "羽田旭町",
  "羽衣町",
  "聖ヶ丘",
  "能ヶ谷",
  "臨海町",
  "自由が丘",
  "興野",
  "舎人",
  "舟渡",
  "舟町",
  "船堀",
  "船橋",
  "芝",
  "芝久保町",
  "芝公園",
  "芝大門",
  "芝浦",
  "花小金井",
  "花小金井南町",
  "花川戸",
  "花畑",
  "若宮",
  "若宮町",
  "若木",
  "若松町",
  "若林",
  "若葉",
  "若葉台",
  "若葉町",
  "荏原",
  "荒川",
  "荒木町",
  "荻窪",
  "菊川",
  "菊野台",
  "萩中",
  "萩山町",
  "落合",
  "落川",
  "蒲田",
  "蒲田本町",
  "蓮根",
  "蓮沼町",
  "蔵前",
  "蔵敷",
  "藤の台",
  "虎ノ門",
  "袋町",
  "西",
  "西が丘",
  "西つつじヶ丘",
  "西ヶ原",
  "西一之江",
  "西中延",
  "西久保",
  "西亀有",
  "西五反田",
  "西五軒町",
  "西伊興",
  "西保木間",
  "西元町",
  "西六郷",
  "西分町",
  "西原",
  "西原町",
  "西台",
  "西和泉",
  "西品川",
  "西大井",
  "西大泉",
  "西小岩",
  "西小松川町",
  "西尾久",
  "西嶺町",
  "西巣鴨",
  "西府町",
  "西恋ヶ窪",
  "西新井",
  "西新井本町",
  "西新井栄町",
  "西新宿",
  "西新小岩",
  "西新橋",
  "西日暮里",
  "西早稲田",
  "西水元",
  "西池袋",
  "西浅草",
  "西片",
  "西片倉",
  "西瑞江",
  "西町",
  "西砂町",
  "西神田",
  "西竹の塚",
  "西糀谷",
  "西綾瀬",
  "西荻北",
  "西荻南",
  "西落合",
  "西葛西",
  "西蒲田",
  "西野川",
  "西馬込",
  "西麻布",
  "要町",
  "調布ヶ丘",
  "諏訪",
  "諏訪町",
  "谷中",
  "谷保",
  "谷原",
  "谷在家",
  "谷戸町",
  "谷河内",
  "豊ヶ丘",
  "豊島",
  "豊洲",
  "豊玉上",
  "豊玉中",
  "豊玉北",
  "豊玉南",
  "豊田",
  "豊町",
  "豪徳寺",
  "貝取",
  "貫井",
  "貫井北町",
  "貫井南町",
  "赤坂",
  "赤城下町",
  "赤城元町",
  "赤堤",
  "赤塚",
  "赤塚新町",
  "赤羽",
  "赤羽北",
  "赤羽南",
  "赤羽台",
  "赤羽西",
  "越中島",
  "越野",
  "足立",
  "辰巳",
  "辰沼",
  "追分町",
  "連光寺",
  "道玄坂",
  "郷地町",
  "野上町",
  "野口町",
  "野塩",
  "野崎",
  "野方",
  "野毛",
  "野沢",
  "野火止",
  "金井",
  "金井ヶ丘",
  "金井町",
  "金山町",
  "金森",
  "金町",
  "鈴木町",
  "鉢山町",
  "銀座",
  "錦",
  "錦町",
  "錦糸",
  "鎌倉",
  "鎌田",
  "鑓水",
  "長峰",
  "長崎",
  "長房町",
  "長沼町",
  "長淵",
  "門前仲町",
  "関前",
  "関原",
  "関口",
  "関戸",
  "関町北",
  "関町南",
  "関町東",
  "阿佐谷北",
  "阿佐谷南",
  "隼町",
  "雑司が谷",
  "雪谷大塚町",
  "雷門",
  "青井",
  "青戸",
  "青柳",
  "青葉台",
  "青葉町",
  "音羽",
  "須賀町",
  "飛田給",
  "飯田橋",
  "館町",
  "馬場下町",
  "馬引沢",
  "駒場",
  "駒形",
  "駒沢",
  "駒込",
  "高井戸東",
  "高井戸西",
  "高倉町",
  "高円寺北",
  "高円寺南",
  "高尾町",
  "高島平",
  "高幡",
  "高木",
  "高松",
  "高松町",
  "高橋",
  "高田",
  "高田馬場",
  "高砂",
  "高輪",
  "高野台",
  "鳥越",
  "鵜の木",
  "鶯谷町",
  "鶴川",
  "鶴牧",
  "鶴間",
  "鷹番",
  "鷺宮",
  "鹿島",
  "鹿浜",
  "鹿骨",
  "麹町",
  "麻布十番",
  "麻布台",
  "麻布永坂町",
  "麻布狸穴町"
];

// 駅名リスト
export const STATION_NAMES = [
  "お台場海浜公園",
  "お花茶屋",
  "すずかけ台",
  "つくし野",
  "つつじヶ丘",
  "とうきょうスカイツリー",
  "ときわ台",
  "ひばりヶ丘",
  "めじろ台",
  "一之江",
  "一橋学園",
  "万願寺",
  "三ノ輪",
  "三ノ輪橋",
  "三河島",
  "三田",
  "三越前",
  "三軒茶屋",
  "三鷹",
  "三鷹台",
  "上中里",
  "上井草",
  "上北台",
  "上北沢",
  "上板橋",
  "上町",
  "上石神井",
  "上野",
  "上野広小路",
  "上野御徒町",
  "上野毛",
  "下丸子",
  "下井草",
  "下北沢",
  "下板橋",
  "下神明",
  "下落合",
  "下赤塚",
  "下高井戸",
  "不動前",
  "世田谷",
  "世田谷代田",
  "両国",
  "中井",
  "中央大学・明星大学",
  "中延",
  "中村橋",
  "中板橋",
  "中河原",
  "中目黒",
  "中神",
  "中野",
  "中野坂上",
  "中野富士見町",
  "中野新橋",
  "乃木坂",
  "久が原",
  "久我山",
  "久米川",
  "九品仏",
  "九段下",
  "亀戸",
  "亀戸水神",
  "亀有",
  "二子玉川",
  "五反田",
  "五反野",
  "五月台",
  "井の頭公園",
  "井荻",
  "京急蒲田",
  "京成上野",
  "京成小岩",
  "京成曳舟",
  "京成立石",
  "京成金町",
  "京成関屋",
  "京成高砂",
  "京橋",
  "京王よみうりランド",
  "京王八王子",
  "京王堀之内",
  "京王多摩センター",
  "京王多摩川",
  "京王永山",
  "京王片倉",
  "人形町",
  "仙川",
  "代々木",
  "代々木上原",
  "代々木八幡",
  "代々木公園",
  "代官山",
  "代田橋",
  "仲御徒町",
  "住吉",
  "保谷",
  "信濃町",
  "光が丘",
  "入谷",
  "八丁堀",
  "八坂",
  "八幡山",
  "八広",
  "八潮",
  "八王子",
  "八王子みなみ野",
  "六本木",
  "六本木一丁目",
  "六町",
  "六郷土手",
  "内幸町",
  "分倍河原",
  "初台",
  "勝どき",
  "北八王子",
  "北千住",
  "北千束",
  "北参道",
  "北品川",
  "北府中",
  "北池袋",
  "北綾瀬",
  "北赤羽",
  "北野",
  "十条",
  "千住大橋",
  "千川",
  "千歳烏山",
  "千歳船橋",
  "千石",
  "千駄ヶ谷",
  "千駄木",
  "千鳥町",
  "半蔵門",
  "南千住",
  "南多摩",
  "南大沢",
  "南平",
  "南新宿",
  "南町田グランベリーパーク",
  "南砂町",
  "南阿佐ヶ谷",
  "南鳩ヶ谷",
  "原宿",
  "参宮橋",
  "古淵",
  "吉祥寺",
  "向原",
  "和光市",
  "和泉多摩川",
  "品川",
  "品川シーサイド",
  "唐木田",
  "喜多見",
  "四ツ木",
  "四ツ谷",
  "四谷三丁目",
  "国分寺",
  "国立",
  "国立競技場",
  "国際展示場",
  "国領",
  "地下鉄成増",
  "地下鉄赤塚",
  "堀切",
  "堀切菖蒲園",
  "外苑前",
  "多摩センター",
  "多摩動物公園",
  "多摩境",
  "多摩川",
  "多摩湖",
  "多磨",
  "多磨霊園",
  "大久保",
  "大井町",
  "大井競馬場前",
  "大塚",
  "大塚・帝京大学",
  "大山",
  "大岡山",
  "大島",
  "大崎",
  "大崎広小路",
  "大師前",
  "大手町",
  "大森",
  "大森海岸",
  "大森町",
  "大泉学園",
  "大門",
  "大鳥居",
  "天王洲アイル",
  "天空橋",
  "奥沢",
  "学習院下",
  "学芸大学",
  "宝町",
  "宮の坂",
  "宮ノ平",
  "富士見ヶ丘",
  "富士見台",
  "小伝馬町",
  "小作",
  "小台",
  "小宮",
  "小岩",
  "小川",
  "小川町",
  "小平",
  "小村井",
  "小田急多摩センター",
  "小田急永山",
  "小竹向原",
  "小菅",
  "尾久",
  "尾山台",
  "山下",
  "山田",
  "岩本町",
  "川口",
  "巣鴨",
  "巣鴨新田",
  "市ヶ谷",
  "布田",
  "幡ヶ谷",
  "平井",
  "平和台",
  "平和島",
  "平山城址公園",
  "広尾",
  "庚申塚",
  "府中",
  "府中本町",
  "府中競馬正門前",
  "後楽園",
  "御嶽山",
  "御徒町",
  "御成門",
  "御茶ノ水",
  "志村三丁目",
  "志村坂上",
  "志茂",
  "恋ヶ窪",
  "恵比寿",
  "成城学園前",
  "成増",
  "成瀬",
  "戸越",
  "戸越公園",
  "戸越銀座",
  "所沢",
  "扇大橋",
  "押上",
  "拝島",
  "新三河島",
  "新中野",
  "新井薬師前",
  "新代田",
  "新大久保",
  "新大塚",
  "新宿",
  "新宿三丁目",
  "新宿御苑前",
  "新宿西口",
  "新富町",
  "新小岩",
  "新小平",
  "新小金井",
  "新庚申塚",
  "新御徒町",
  "新御茶ノ水",
  "新日本橋",
  "新板橋",
  "新柴又",
  "新桜台",
  "新橋",
  "新江古田",
  "新百合ヶ丘",
  "新秋津",
  "新豊洲",
  "新馬場",
  "新高円寺",
  "新高島平",
  "方南町",
  "旗の台",
  "日の出",
  "日暮里",
  "日本橋",
  "日比谷",
  "日野",
  "早稲田",
  "明大前",
  "明治神宮前",
  "春日",
  "昭和島",
  "昭島",
  "是政",
  "曙橋",
  "曳舟",
  "月島",
  "有明",
  "有明テニスの森",
  "木場",
  "末広町",
  "本所吾妻橋",
  "本蓮沼",
  "本郷三丁目",
  "本駒込",
  "東あずま",
  "東中神",
  "東中野",
  "東久留米",
  "東京",
  "東京テレポート",
  "東伏見",
  "東北沢",
  "東十条",
  "東向島",
  "東大前",
  "東大和市",
  "東大島",
  "東小金井",
  "東尾久三丁目",
  "東府中",
  "東新宿",
  "東日本橋",
  "東村山",
  "東松原",
  "東武練馬",
  "東池袋",
  "東福生",
  "東秋留",
  "東銀座",
  "東長崎",
  "東陽町",
  "東雲",
  "東青梅",
  "東高円寺",
  "松が谷",
  "松原",
  "松陰神社前",
  "板橋",
  "板橋区役所前",
  "板橋本町",
  "柴又",
  "柴崎",
  "柴崎体育館",
  "柿生",
  "栄町",
  "栗平",
  "根津",
  "桜上水",
  "桜台",
  "桜新町",
  "桜街道",
  "梅ヶ丘",
  "梅屋敷",
  "梅島",
  "梶原",
  "森下",
  "椎名町",
  "橋本",
  "武蔵境",
  "武蔵大和",
  "武蔵小山",
  "武蔵小金井",
  "武蔵新田",
  "武蔵砂川",
  "武蔵野台",
  "武蔵関",
  "水天宮前",
  "水道橋",
  "氷川台",
  "永田町",
  "永福町",
  "汐留",
  "江北",
  "江古田",
  "江戸川",
  "江戸川橋",
  "池ノ上",
  "池上",
  "池尻大橋",
  "池袋",
  "河辺",
  "沼袋",
  "沼部",
  "泉体育館",
  "泉岳寺",
  "洗足",
  "洗足池",
  "浅草",
  "浅草橋",
  "浜松町",
  "浜田山",
  "浜町",
  "浮間舟渡",
  "淡路町",
  "淵野辺",
  "清澄白河",
  "清瀬",
  "渋谷",
  "湯島",
  "溜池山王",
  "滝野川一丁目",
  "潮見",
  "熊川",
  "熊野前",
  "片倉",
  "牛浜",
  "牛田",
  "牛込柳町",
  "牛込神楽坂",
  "狛江",
  "狭間",
  "玉川上水",
  "玉川学園前",
  "王子",
  "王子神谷",
  "瑞江",
  "用賀",
  "田原町",
  "田園調布",
  "田無",
  "田町",
  "田端",
  "甲州街道",
  "町屋",
  "町屋二丁目",
  "町屋駅前",
  "町田",
  "白山",
  "白糸台",
  "白金台",
  "白金高輪",
  "百草園",
  "目白",
  "目黒",
  "相原",
  "相模原",
  "矢口渡",
  "矢川",
  "矢部",
  "矢野口",
  "石川台",
  "石神井公園",
  "砂川七番",
  "祐天寺",
  "祖師ヶ谷大蔵",
  "神保町",
  "神楽坂",
  "神泉",
  "神田",
  "神谷町",
  "福生",
  "秋川",
  "秋津",
  "秋葉原",
  "程久保",
  "稲城",
  "稲城長沼",
  "稲荷町",
  "穴守稲荷",
  "立会川",
  "立川",
  "立川北",
  "立川南",
  "競艇場前",
  "竹ノ塚",
  "竹橋",
  "竹芝",
  "笹塚",
  "等々力",
  "箱根ヶ崎",
  "築地",
  "築地市場",
  "篠崎",
  "糀谷",
  "経堂",
  "綾瀬",
  "緑が丘",
  "練馬",
  "練馬春日町",
  "練馬高野台",
  "羽村",
  "聖蹟桜ヶ丘",
  "自由が丘",
  "舎人",
  "舎人公園",
  "船堀",
  "芝公園",
  "芝浦ふ頭",
  "芦花公園",
  "花小金井",
  "若松河田",
  "若林",
  "若葉台",
  "茅場町",
  "茗荷谷",
  "荏原中延",
  "荏原町",
  "荒川一中前",
  "荒川二丁目",
  "荒川区役所前",
  "荒川車庫前",
  "荒川遊園地前",
  "荻窪",
  "菊川",
  "萩山",
  "落合",
  "落合南長崎",
  "葛西",
  "葛西臨海公園",
  "蒲田",
  "蓮根",
  "蓮沼",
  "蔵前",
  "虎ノ門",
  "虎ノ門ヒルズ",
  "表参道",
  "西ヶ原",
  "西ヶ原四丁目",
  "西八王子",
  "西台",
  "西国分寺",
  "西国立",
  "西大井",
  "西大島",
  "西太子堂",
  "西小山",
  "西巣鴨",
  "西府",
  "西新井",
  "西新井大師西",
  "西新宿",
  "西新宿五丁目",
  "西日暮里",
  "西早稲田",
  "西武新宿",
  "西武柳沢",
  "西武立川",
  "西永福",
  "西立川",
  "西荻窪",
  "西葛西",
  "西調布",
  "西馬込",
  "西高島平",
  "要町",
  "見沼代親水公園",
  "調布",
  "護国寺",
  "谷保",
  "谷在家",
  "谷塚",
  "豊島園",
  "豊洲",
  "豊田",
  "豪徳寺",
  "赤土小学校前",
  "赤坂",
  "赤坂見附",
  "赤羽",
  "赤羽岩淵",
  "赤羽橋",
  "越中島",
  "足立小台",
  "辰巳",
  "都庁前",
  "都立大学",
  "都立家政",
  "都電雑司ヶ谷",
  "野方",
  "金町",
  "銀座",
  "銀座一丁目",
  "錦糸町",
  "鐘ヶ淵",
  "長原",
  "長沼",
  "門前仲町",
  "阿佐ヶ谷",
  "雑司が谷",
  "雑色",
  "雪が谷大塚",
  "青井",
  "青山一丁目",
  "青梅",
  "青梅街道",
  "青物横丁",
  "青砥",
  "面影橋",
  "飛田給",
  "飛鳥山",
  "飯田橋",
  "馬喰横山",
  "馬喰町",
  "馬込",
  "駒場東大前",
  "駒沢大学",
  "駒込",
  "高井戸",
  "高円寺",
  "高尾",
  "高尾山口",
  "高島平",
  "高幡不動",
  "高松",
  "高田馬場",
  "高輪ゲートウェイ",
  "高輪台",
  "高野",
  "鮫洲",
  "鵜の木",
  "鶯谷",
  "鶴川",
  "鷹の台",
  "鷺ノ宮",
  "麹町",
  "麻布十番",
  "黒川",
];

// 建物の構造リスト
export const STRUCTURE_TYPES = [
  { key: "RC", label: "RC" },
  { key: "SRC", label: "SRC" },
  { key: "ブロック造", label: "ブロック造" },
  { key: "木造", label: "木造" },
  { key: "軽量鉄骨造", label: "軽量鉄骨造" },
  { key: "鉄骨造", label: "鉄骨造" },
];

// 都市計画リスト
export const CITY_PLANNING_TYPES = [
  { key: "1低住専", label: "第一種低層住居専用地域" },
  { key: "1中住専", label: "第一種中高層住居専用地域" },
  { key: "1種住居", label: "第一種住居地域" },
  { key: "2低住専", label: "第二種低層住居専用地域" },
  { key: "2中住専", label: "第二種中高層住居専用地域" },
  { key: "2種住居", label: "第二種住居地域" },
  { key: "商業", label: "商業地域" },
  { key: "近隣商業", label: "近隣商業地域" },
  { key: "工業", label: "工業地域" },
  { key: "工業専用", label: "工業専用地域" },
  { key: "準住居", label: "準住居地域" },
  { key: "準工業", label: "準工業地域" },
  { key: "準都計", label: "準都市計画区域" },
  { key: "調整区域", label: "市街化調整区域" },
  { key: "都計外", label: "都市計画区域外" },
  { key: "非線引き", label: "非線引き都市計画区域" },
];

// 間取りリスト
export const LAYOUT_TYPES = [
  { key: "single", label: "単身者向けコンパクト間取り(1Rや1Kなど)" },
  { key: "single_or_couple", label: "単身者・カップル向け広めの間取り(1DKや1LDKなど)" },
  { key: "small_family", label: "小家族向け2部屋間取り(2DKや2LDKなど)" },
  { key: "medium_family", label: "家族向け3部屋間取り(3DKや3LDKなど)" },
  { key: "large_family", label: "大家族向け4部屋以上の大型間取り(4LDKや5LDKなど)" },
  { key: "special", label: "特殊な間取り(オープンフロアやメゾネットなど)" },
];

// 改装の有無リスト
export const RENOVATION_TYPES = [
  { key: "改装無", label: "改装無" },
  { key: "改装済み", label: "改装済み" },
];

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(91), (_, index) => String(currentYear - 70 + index));
  return years;
};
